const STOP = new Set(["the", "and", "how", "what", "my", "can", "you", "for", "does", "do", "is", "are", "a", "an", "to", "of", "i", "it", "in", "on", "your", "with", "when", "why", "will", "get"]);
export const faqWords = (q) => (q.toLowerCase().match(/[a-z0-9']+/g) || []).filter((w) => w.length > 2 && !STOP.has(w));
export const faqStem = (w) => (w.length > 4 ? w.replace(/(ing|ed|es|s)$/, "") : w);
export const escRx = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function faqScore(item, terms) {
  return terms.reduce((s, w) => {
    const rx = new RegExp(`\\b${escRx(faqStem(w))}`, "i");
    return s + (rx.test(item.question) ? 3 : 0) + (rx.test(item.topic) ? 2 : 0) + (rx.test(item.answer) ? 1 : 0);
  }, 0);
}

export const faqSearch = (items, terms) =>
  items.map((i) => [faqScore(i, terms), i]).filter(([s]) => s > 0).sort((x, y) => y[0] - x[0]).map(([, i]) => i);
